const ShippingDetails = ({ customer, tCommon }) => {
  const shipping = customer?.shippingAddress;
  const phone = customer?.phoneNumber;
  const email = customer?.email;
  const fullAddress = [
    shipping?.line1,
    shipping?.street,
    shipping?.city,
    shipping?.zipCode,
    shipping?.country,
  ]
    .filter(Boolean)
    .join(", ");
  return (
    <div className="border-supportiveDarkGray space-y-2 border p-4 text-sm md:text-base">
      <span className="border-supportiveDarkGray bg-supportiveThinGray inline-block border px-2 py-1 text-sm">
        {tCommon("Shipped_To")}
      </span>
      <address className="space-y-1 not-italic text-[#79747E]">
        {fullAddress && <p>{fullAddress}</p>}
        {phone && <p>{phone}</p>}
        {email && <p>{email}</p>}
      </address>
    </div>
  );
};

export default ShippingDetails;
